import React,{useContext} from "react";
import AuthContext from '../../AuthContext'
const UserTypeDropdown = ({ handleInputChange, userType, imp }) => {
  const auth =useContext(AuthContext)
  const handleUserTypeChange = (e) => {
    handleInputChange({ target: { name: "user_type", value: e.target.value } });
  };
  return (
    <div>
      <label htmlFor="user_type" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        User Type&nbsp;
        {imp && <span className="text-red-600">*</span>}
      </label>
      <select
        id="user_type"
        name="user_type"
        value={userType}
        onChange={handleUserTypeChange}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      >
        <option value="">Select User Type</option>
       {auth.userType==='Superadmin' && <option value="Superadmin">Super Admin</option>}
        <option value="Admin">Centre Manager</option>
       {auth.userType==='Superadmin'&&  <option value="Manager">MIS Manager</option>}
        <option value="Accounts">Accounts</option>
        <option value="HR">HR</option>


        {/* Add more options as needed */}
      </select>
    </div>
  );
};

export default UserTypeDropdown;
